import { Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { merge, switchMap, throwError } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { generateUuid } from '@recruitee/utils';

import { SaveParams } from './full-candidate-http-client';
import { FullCandidateActions, FullCandidateSelectors } from './full-candidate.store';

@Injectable({ providedIn: 'root' })
export class FullCandidateDataService {
  constructor(private store: Store, private actions$: Actions) {}

  public save(params: SaveParams) {
    return params.data.id ? this.updateCandidate(params) : this.createCandidate(params);
  }

  public updateCandidate(params: SaveParams) {
    const candidateId = params.data.id!;
    this.store.dispatch(FullCandidateActions.updateOnePessimistic({ payload: { params } }));
    return merge(
      this.actions$.pipe(
        ofType(FullCandidateActions.updateOnePessimisticSuccess),
        filter(({ payload }) => payload.data.id === candidateId),
        switchMap(() => this.store.select(FullCandidateSelectors.byIdWithReferences(candidateId))),
        filterBoolean,
      ),
      this.actions$.pipe(
        ofType(FullCandidateActions.updateOnePessimisticFailed),
        filter(({ payload }) => payload.data.id === candidateId),
        switchMap(({ payload }) => throwError(payload.error)),
      ),
    ).pipe(take(1));
  }

  public createCandidate(params: SaveParams) {
    const correlationId = generateUuid();
    this.store.dispatch(
      FullCandidateActions.createOnePessimistic({ payload: { params, correlationId } }),
    );
    return merge(
      this.actions$.pipe(
        ofType(FullCandidateActions.createOnePessimisticSuccess),
        filter(({ payload }) => payload.correlationId === correlationId),
        switchMap(({ payload }) =>
          this.store.select(FullCandidateSelectors.byIdWithReferences(payload.data.id)),
        ),
        filterBoolean,
      ),
      this.actions$.pipe(
        ofType(FullCandidateActions.createOnePessimisticFailed),
        filter(({ payload }) => payload.correlationId === correlationId),
        switchMap(({ payload }) => throwError(payload.error)),
      ),
    ).pipe(take(1));
  }
}
